import { AppContent } from 'content/AppContent';

const mobileNumberMissing: AppContent['mobileNumberMissing'] = {
  mobileNumberMissingContent: [
    {
      serviceName: 'Business Internet Banking',
      header: 'We don’t have a mobile number for you',
      infoNotification:
        'To register online, we’ll need a mobile number for you',
      content1:
        'That’s so we can text you a passcode to confirm it’s really you.',
      content2:
        'We also need your mobile number in case we need to get in touch. Or check it’s you when you’re making online purchases and payments.',
      content3: 'What to do next:',
      fillOutFormText: 'Fill out this form',
      fillOutFormLink:
        'https://apply.bankofscotland.co.uk/sales-content/cwa/b/gforms/F213/?WT.ac=BoS-help_support-amendphone-chldpage-accmgmt-FOM-amend_phone_number#/?_k=v8k04v',
      listItem1: 'to tell us your mobile number.',
      listItem2: 'Print and sign it.',
      listItem3: 'Post it back to us.',
      backToWebsiteButton: 'Back to bankofscotland.com',
      backToWebsiteLink:
        'https://business.bankofscotland.co.uk/online-banking/registration.html',
    },
  ],
};

export default mobileNumberMissing;
